module.exports = __webpack_public_path__ + "img/9788925558158.1cfbc432.jpg";